import TrackingService from 'common/tracking/services/TrackingService'
import * as boardActions from 'LiveBoard/modules/board'
import * as itemsActions from 'LiveBoard/modules/items'
import * as itemViewerActions from 'LiveBoard/modules/itemViewer'
import * as itemsViewActions from 'LiveBoard/modules/itemsView'
import * as gatingFormActions from 'LiveBoard/modules/gatingForm'
import { CLOSE_PRIVACY_WARNING } from 'LiveBoard/modules/cookiesConsent'
import * as ctaActions from 'LiveBoard/modules/cta'
import get from 'lodash/get'

const instance = TrackingService()
const EVENTS = instance.config.events.lead

const ACTION_TO_EVENT = {
  [boardActions.TRACK_VIEWED_BOARD]: EVENTS.viewed_board,
  [itemsActions.TRACK_VIEWED_ITEM]: EVENTS.viewed_item,
  [itemViewerActions.TRACK_CLICKED_ON_NEXT_ITEM]: EVENTS.clicked_on_next_item,
  [itemViewerActions.TRACK_CLICKED_ON_PREV_ITEM]: EVENTS.clicked_on_previous_item,
  [itemViewerActions.LIKE_ITEM_SUCCESS]: EVENTS.liked_an_item,
  [itemViewerActions.TRACK_ITEM_DOWNLOADED]: EVENTS.downloaded_an_item,
  [CLOSE_PRIVACY_WARNING]: EVENTS.confirmed_cookie_usage,
  [ctaActions.TRACK_SHARE_CLICK]: EVENTS.clicked_on_share_button,
  [ctaActions.SHARE_BY_EMAIL_SUCCESS]: EVENTS.shared_a_campaign,
  [ctaActions.SUBMIT_CTA_SUCCESS]: EVENTS.clicked_on_cta,
  [itemsViewActions.SET_CATEGORY]: EVENTS.changed_category,
  [itemsViewActions.SET_SEARCH_QUERY]: EVENTS.searched_items
}

const Tracker = store => next => action => {
  const event = get(ACTION_TO_EVENT, action.type)

  if (event) {
    const { board } = store.getState()

    instance.liveBoardTrack(event, {
      ...action.trackingParams,
      board_id: board.id,
      board_name: board.name
    }, instance.config.platforms.campaign)
  }

  next(action)
}

export default Tracker
